<template>
  <button
    :class="[
      $style.button,
      $style[variant],
      { [$style.inverse]: inverse },
      { [$style.iconBefore]: iconBefore },
      { [$style.iconAfter]: iconAfter },
      { [$style.asLink]: asLink }
    ]"
    @click="$emit('click', $event)"
    :disabled="disabled"
  >
    <icon
      v-if="iconBefore"
      :icon="iconBefore"
      :class="$style.iconLeft"
    ></icon>
    <slot></slot>
    <icon
      v-if="iconAfter"
      :icon="iconAfter"
      :class="$style.iconRight"
    ></icon>
  </button>
</template>

<script>
import icon from "../display/icon";

export default {
  name: "button-fragment",
  components: { icon },
  props: {
    variant: {
      type: String,
      required: false,
      default: "primary",
      validator: function(value) {
        return ["primary", "success", "danger"].indexOf(value) !== -1;
      }
    },
    inverse: { type: Boolean, default: false },
    iconBefore: { type: String },
    iconAfter: { type: String },
    asLink: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors.scss";
@import "../../style/abstract/abstract.functions.scss";
@import "../../style/abstract/abstract.typography.scss";

.button {
  border: none;
  cursor: pointer;
  font-weight: bold;
  line-height: 1.3125;
  color: $color-white;
  font-size: rem-calc(15);
  border-radius: rem-calc(4);
  font-family: $font-family-bold;
  padding: rem-calc(14) rem-calc(30);
}

.primary {
  background-color: $color-primary;

  &.inverse {
    color: $color-primary;
  }

  &:hover {
    color: $color-white;
    background-color: $color-primary-dark;
  }

  &:disabled {
    background-color: $color-silver;
    cursor: not-allowed;
  }
}

.success {
  color: $color-white;
  background-color: $color-success;

  &.inverse {
    color: darken($color-success, 10%);
  }

  &:hover {
    color: $color-white;
    background-color: darken($color-success, 10%);
  }

  &:disabled {
    background-color: $color-silver;
    cursor: not-allowed;
  }
}

.danger {
  color: $color-white;
  background-color: $color-attention;

  &.inverse {
    color: darken($color-attention, 10%);
  }

  &:hover {
    color: $color-white;
    background-color: darken($color-attention, 10%);
  }

  &:disabled {
    background-color: $color-silver;
    cursor: not-allowed;
  }
}

.iconButton {
  position: relative;
  font-family: $font-family;
}

.iconBefore {
  composes: iconButton;
  padding-left: rem-calc(60);
}

.iconAfter {
  composes: iconButton;
  padding-right: rem-calc(60);
}

.iconStyling {
  top: 50%;
  position: absolute;
  transform: translate(0, -50%);
}

.iconLeft {
  composes: iconStyling;
  left: rem-calc(30);
}

.iconRight {
  composes: iconStyling;
  right: rem-calc(30);
}

.asLink {
  color: $color-primary;
  background-color: transparent;
  font-weight: normal;

  &:hover {
    color: $color-primary-dark;
    background-color: transparent;

    &.primary {
      color: $color-primary-dark;
    }

    &.danger {
      color: darken($color-attention, 10%);
    }

    &.success {
      color: darken($color-success, 10%);
    }

    &:disabled {
      color: $color-silver;
    }
  }

  &.primary {
    color: $color-primary;
  }

  &.danger {
    color: $color-attention;
  }

  &.success {
    color: $color-success;
  }

  &:disabled {
    color: $color-silver;
    background-color: transparent;
  }
}

.inverse {
  color: $color-primary;
  background-color: $color-white;
  border: rem-calc(1) solid $color-primary;

  &:hover {

    &.primary {
      color: $color-white;
      background-color: $color-primary-dark;
    }

    &.danger {
      color: $color-white;
      background-color: $color-attention;
    }

    &.success {
      color: $color-white;
      background-color: $color-success;
    }

    &:disabled {
      color: $color-silver;
      background-color: $color-white;
      border-color: $color-silver;
    }
  }

  &.primary {
    color: $color-primary;
    border-color: $color-primary;
  }

  &.danger {
    color: $color-attention;
    border-color: $color-attention;
  }

  &.success {
    color: $color-success;
    border-color: $color-success;
  }

  &:disabled {
    color: $color-silver;
    background-color: $color-white;
    border-color: $color-silver;
  }
}
</style>
